<div class="dashboard-content-sec">

    <div class="card hide-overflow">
        <div class="card-body">
            <h5 class="card-title">Hiring</h5>
            <div class="card-body">
                <div class="btn-group d-none d-md-block">
                    <button class="btn btn-light" [ngClass]="{'active': buttonSelected=='overview'}" id="overview" 
                        (click)="selectButton($event)">Overview
                    </button>
                    <button class="btn btn-light" [ngClass]="{'active': buttonSelected=='job-postings'}" id="job-postings" 
                        (click)="selectButton($event)">Job Postings
                    </button>
                    <button class="btn btn-light" [ngClass]="{'active': buttonSelected=='interview-process'}" id="interview-process"
                        (click)="selectButton($event)">Interview Process
                    </button>
                    <button class="btn btn-light" id="background-checks" (click)="selectButton($event)">Background Checks</button>
                    <button class="btn btn-light" id="faqs" (click)="selectButton($event)">FAQs & Resources</button>
                    <button class="btn btn-light" id="docs" (click)="selectButton($event)">Docs & Forms</button>
                </div>

                <div class="btn-group-vertical d-sm-block d-md-none">
                    <button class="btn btn-light" [ngClass]="{'active': buttonSelected=='overview'}" id="overview" 
                        (click)="selectButton($event)">Overview
                    </button>
                    <button class="btn btn-light" [ngClass]="{'active': buttonSelected=='job-postings'}" id="job-postings" 
                        (click)="selectButton($event)">Job Postings
                    </button>
                    <button class="btn btn-light" [ngClass]="{'active': buttonSelected=='interview-process'}" id="interview-process"
                        (click)="selectButton($event)">Interview Process
                    </button>
                    <button class="btn btn-light" id="background-checks" (click)="selectButton($event)">Background Checks</button>
                    <button class="btn btn-light" id="faqs" (click)="selectButton($event)">FAQs & Resources</button>
                    <button class="btn btn-light" id="docs" (click)="selectButton($event)">Docs & Forms</button>
                </div>
    
            </div>
        </div>
    

    <div *ngIf="buttonSelected=='overview'" class='card-detail card-body'>
        <h5 class="card-title">Overview</h5>

        <p>Finding the perfect person to join your team requires more than just a well worded  
        internet job posting.  The process of drafting legally compliant applications,  
        reviewing those applications, the process of selecting candidates to interview,  
        the interview process and questions that are appropriate to ask a candidate along 
        with background checks are filled with potential legal pitfalls long before resumes 
        start flooding your inbox.</p>  
        <p>
        You will be able to find information on
        Forms, Checklists, Resources and FAQs to help with a smooth hiring
        process.  
        </p>
    </div>

    <div *ngIf="buttonSelected=='job-postings'" class='card-detail card-body'>
        <h5 class="card-title">Job Postings</h5>
        <p>Before you think about the qualities a perfect candidate will have, think about what you need that candidate to do.  Recent and accurate job descriptions are a must have before you begin your search, and can protect your legal interests.  Use our job description templates to know what you need before you start to look.
        </p>
        <p>
          Federal and state laws do not require employers to have written job descriptions for their employees. However, many employers do because of their usefulness in many aspects of the business, from hiring to compensation to managing employee performance. While there are many practical benefits to having job descriptions, these documents also raise legal implications. A poorly drafted job description can increase litigation risks by providing evidence employees can use in wage and hour, discrimination and other employment-related lawsuits.
        </p>
        <p>
          Before you think about the qualities a perfect candidate will have, think about what you need that candidate to do.  Recent and accurate job descriptions are a must have before you begin your search, and can protect your legal interests.  Use our job description templates to know what you need before you start to look.
        </p>
        <p>
          Federal and state laws do not require employers to have written job descriptions for their employees. However, many employers do because of their usefulness in many aspects of the business, from hiring to compensation to managing employee performance. While there are many practical benefits to having job descriptions, these documents also raise legal implications. A poorly drafted job description can increase litigation risks by providing evidence employees can use in wage and hour, discrimination and other employment-related lawsuits.
        </p>
        <h5>Elements of a Job Description</h5>
        <p>
          A job description is a document that describes certain details about a particular position. It typically contains the following elements:
        </p>

          
        <h5>Job title</h5>
          <p>The document may also specify a job code applicable to the employer's internal operations, pay grade and to whom the position reports.
          </p>

          <h5>Job classification.</h5>
          <p>A job description often specifies whether a job is:</p>
            <ul>
                <li>exempt or nonexempt from pay requirements under federal and applicable state laws;
                </li>
                <li>full or part-time; or</li>
                <li>a temporary, contract or regular position.</li>
            </ul>

        <h5>Duties.</h5>
        <p>A job description should specify the responsibilities, duties, tasks and requirements of the job (for more information.
        </p>

Qualifications. The qualifications needed for the job should be listed. Some employers separately list qualifications that are required versus those that are preferred. These qualification can include, for example:

education level;

any professional or other required licenses or certifications;

prior work experience in a particular field or type of position;

skills, such as proficiency in computer software or word processing systems; or

traits, such as attention to detail or the ability to work under time pressures.

Physical requirements. The job description can specify the physical requirements of the job, such as standing, sitting, lifting requirements and the physical work environment.

Additional information. The job description can include other information, such as location, travel requirements and working hours.

While written job descriptions are not required by law, employers covered by the Equal Pay Act (EPA) that create written job descriptions must preserve them (any other are records created in the regular course of business that contain wage payment-related information) for two years.


            
            Elements of a Job Description
            A job description is a document that describes certain details about a particular position. It typically contains the following elements:
            
            Job title. The document may also specify a job code applicable to the employer's internal operations, pay grade and to whom the position reports.
            
            Job classification. A job description often specifies whether a job is:
            
            exempt or nonexempt from pay requirements under federal and applicable state laws;
            
            full or part-time; or
            
            a temporary, contract or regular position.
            
            Duties. A job description should specify the responsibilities, duties, tasks and requirements of the job (for more information.
            
            Qualifications. The qualifications needed for the job should be listed. Some employers separately list qualifications that are required versus those that are preferred. These qualification can include, for example:
            
            education level;
            
            any professional or other required licenses or certifications;
            
            prior work experience in a particular field or type of position;
            
            skills, such as proficiency in computer software or word processing systems; or
            
            traits, such as attention to detail or the ability to work under time pressures.
            
            Physical requirements. The job description can specify the physical requirements of the job, such as standing, sitting, lifting requirements and the physical work environment.
            
            Additional information. The job description can include other information, such as location, travel requirements and working hours.
            
            While written job descriptions are not required by law, employers covered by the Equal Pay Act (EPA) that create written job descriptions must preserve them (any other are records created in the regular course of business that contain wage payment-related information) for two years.
            
            
    </div>
    

    <div *ngIf="buttonSelected=='interview-process'" class='card-detail card-body'>
            <h5 class="card-title">Interview Process</h5>
    
            <p>Finding the perfect person to join your team requires more than just a well worded  
            internet job posting.  The process of drafting legally compliant applications,  
            reviewing those applications, the process of selecting candidates to interview,  
            the interview process and questions that are appropriate to ask a candidate along 
            with background checks are filled with potential legal pitfalls long before resumes 
            start flooding your inbox.</p>  
            <p>
            You will be able to find information on
            Forms, Checklists, Resources and FAQs to help with a smooth hiring
            process.  
            </p>
    </div>

    </div>    
</div>